import SparkMD5 from "spark-md5";

const CHUNK_SIZE = 2 * 1024 * 1024;

function hexToBase64(hex: string): string {
  let binary = "";
  for (let index = 0; index < hex.length; index += 2) {
    binary += String.fromCharCode(Number.parseInt(hex.slice(index, index + 2), 16));
  }
  return btoa(binary);
}

export async function fileMd5(file: Blob): Promise<string> {
  const hasher = new SparkMD5.ArrayBuffer();
  for (let offset = 0; offset < file.size; offset += CHUNK_SIZE) {
    hasher.append(await file.slice(offset, Math.min(offset + CHUNK_SIZE, file.size)).arrayBuffer());
  }
  return hexToBase64(hasher.end());
}
